import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PejabatProvider } from "@/context/PejabatContext";
import Pengaturan from "@/pages/Pengaturan";
import AgendaSurat from "@/pages/AgendaSurat";
import CetakRekapSurat from "@/pages/CetakRekapSurat";
import Verifikasi from "@/pages/Verifikasi";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DataWarga from "@/pages/DataWarga";
import RekapRT from "@/pages/RekapRT";
import Mutasi from "@/pages/Mutasi";
import CetakRekap from "@/pages/CetakRekap";
import LayananSurat from "@/pages/LayananSurat";
import BuatSurat from "@/pages/BuatSurat";
import CetakSurat from "@/pages/CetakSurat";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-sm text-slate-500" data-testid="auth-loading">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/cetak" element={<Protected><CetakRekap /></Protected>} />
      <Route path="/cetak-rekap-surat" element={<Protected><CetakRekapSurat /></Protected>} />
      <Route path="/verifikasi/:id" element={<Verifikasi />} />
      <Route path="/surat/:id/cetak" element={<Protected><CetakSurat /></Protected>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/warga" element={<DataWarga />} />
        <Route path="/rekap" element={<RekapRT />} />
        <Route path="/mutasi" element={<Mutasi />} />
        <Route path="/surat" element={<LayananSurat />} />
        <Route path="/surat/baru" element={<BuatSurat />} />
        <Route path="/pengaturan" element={<Pengaturan />} />
        <Route path="/agenda" element={<AgendaSurat />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <PejabatProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      </PejabatProvider>
      <Toaster richColors position="bottom-right" />
    </AuthProvider>
  );
}
